import './TemplateSettings.scss';
import { Spin } from 'antd';
import EventEmitterComponent from '&/components/EventEmitterComponent';
import TemplateTree from '@/components/TemplateSettings';
import TemplateDetail from '@/components/TemplateSettings/TemplateDetail';

export default function TemplateSettings() {
    const [loading, setLoading] = useState(false);
    return (
        <EventEmitterComponent>
            <Spin spinning={loading}>
                <div key={1} className="card-content template-settings-card">
                    <TemplateTree setLoading={setLoading} />
                    <TemplateDetail />
                </div>
            </Spin>
        </EventEmitterComponent>
    );
}
